import React, { useState, useRef, useEffect } from "react";
import { observer } from "mobx-react";
import DashboardTabItem from "./DashboardTabItem";
import dashboardV2Store from "../store/dashboardV2Store";

const DashboardHeader = observer(() => {
  const [savingDash, setSavingDash] = useState(false);
  const [newDashName, setNewDashName] = useState("");
  const dropdownRef = useRef(null);

  const { dashboards, activeDashboardId, isCreatingDashboard } = dashboardV2Store;

  useEffect(() => {
    const handleClickOutside = e => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setSavingDash(false);
        setNewDashName("");
      }
    };
    if (savingDash) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [savingDash]);

  const saveDash = async () => {
    const trimmed = newDashName.trim();
    if (!trimmed) return;
    await dashboardV2Store.createDashboard(trimmed);
    setSavingDash(false);
    setNewDashName("");
  };

  const handleKeyDown = e => {
    if (e.key === "Enter") saveDash();
    if (e.key === "Escape") {
      setSavingDash(false);
      setNewDashName("");
    }
  };

  return (
    <div className="dashboardV2TabRow" ref={dropdownRef}>
      <div className="dashboardV2Tabs">
        {dashboards.map(d => (
          <DashboardTabItem
            key={d.id}
            name={d.name}
            widgetCount={d.widgets?.length || 0}
            isActive={d.id === activeDashboardId}
            isDefault={d.default}
            onClick={() => dashboardV2Store.setActiveDashboardId(d.id)}
            onDelete={() => dashboardV2Store.deleteDashboard(d.id)}
          />
        ))}
      </div>

      <div className="dashboardV2AddTabWrap">
        <button
          type="button"
          className="dashboardV2AddTabBtn"
          onClick={e => {
            e.stopPropagation();
            setSavingDash(s => !s);
          }}
          title="Create new dashboard"
        >
          +
        </button>

        {savingDash && (
          <div
            className="dashboardV2CreateDropdown"
            onClick={e => e.stopPropagation()}
          >
            <p className="dashboardV2CreateDropdownTitle">
              Name this dashboard
            </p>
            <input
              autoFocus
              className="dashboardV2CreateDropdownInput"
              value={newDashName}
              onChange={e => setNewDashName(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="e.g. SDR standup…"
              maxLength={60}
            />
            <div className="dashboardV2CreateDropdownActions">
              <button
                type="button"
                className="dashboardV2CreateCancelBtn"
                onClick={() => {
                  setSavingDash(false);
                  setNewDashName("");
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className={`dashboardV2CreateSaveBtn${!newDashName.trim() || isCreatingDashboard ? " dashboardV2CreateSaveBtnDisabled" : ""}`}
                onClick={saveDash}
                disabled={!newDashName.trim() || isCreatingDashboard}
              >
                {isCreatingDashboard ? "Saving…" : "Save"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default DashboardHeader;
